// extracted by mini-css-extract-plugin
export default {"container":"accordian_container__qtMrl","header":"accordian_header__WDyt6","content":"accordian_content__0FnEh"};